/**
 * Counts the number of characters in the text.
 * @param {string} text - The text to analyze.
 * @returns {number} The number of characters in the text.
 */
export function countCharacters(text: string): number {
  return text.length;
}
